






import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class FormCheckbox extends Vue {
  @Prop({ default: false }) checked?: boolean; // label文本
}
